











import * as R from 'ramda';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { i18n } from '@/plugins/i18n/i18n';
import { TaskMetadataArgsHint } from '@/types/type';

@Component
export default class TaskMetadataArgHint extends Vue {
  @Prop()
  private hints!: TaskMetadataArgsHint[];

  private getHint(): string {
    const findHint = (lang: string) =>
      R.unless(
        R.isNil,
        R.pipe(R.find(R.propEq('language', lang)), R.path(['hint']))
      );

    const i18nLocale = i18n.locale;
    const i18nfallbackLocale = i18n.fallbackLocale as string;

    return (findHint(i18nLocale)(this.hints) ||
      findHint(i18nfallbackLocale)(this.hints)) as string;
  }
}
